import React from "react";
import Dropzone from "react-dropzone";
import {
  Row,
  Col,
  Spinner,
  Button,
  Image,
} from "react-bootstrap";
import { FaHdd, FaRegCheckCircle, FaSearch } from "react-icons/fa";
import { MdOutlinePageview } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineCloseCircle, AiOutlineUpload } from "react-icons/ai";
import { GoLinkExternal } from "react-icons/go";

class BrtxDropzone extends React.Component {
  state = {
    preview: {
      show: false,
      src: "",
    },
    heg: false,
    heg_search: "",
    heg_files: [],
    heg_loading: false,
    link: false,
  };

  uploadFile = (f, idx) => {
    let files = this.props.files;
    let reader = new FileReader();
    reader.readAsDataURL(f);
    reader.onload = () => {
      this.saveEDM(
        idx,
        files[idx].name,
        files[idx].size,
        reader.result.split(",")[1]
      ).then((res) => {
        files[idx] = {
          ...files[idx],
          content: reader.result,
          upload: res.status == 200 ? true : false,
          uploadStatus: res.data,
          id: res.status == 200 ? res.data : -1,
          folder: res.status == 200 ? 4000232 : -1,
        };
        this.setState({ files: files });
        this.props.setfiles(files);
      });
    };
    reader.onerror = function (error) {};
  };

  removeEntries = (f) => {
    let files = this.props.files;
    files.splice(f, 1);
    this.props.setfiles(files);
  };

  pushFile = (f) => {
    let files = this.props.files;
    f.forEach((file) => {                                                                       const idx = files.length;
      const nFile = {
        id: -1,
        folder: -1,
        path: file.path,
        name: file.name,
        type: file.type,
        size: file.size,
        content: "",
        upload: null,
        deletable: true,
      };
      files.push(nFile);
      this.props.setfiles(files);
      this.uploadFile(file, idx);
    });
  };

  componentDidUpdate() {
    
  }

  render() {
    const {Bs, SIZE,VARIANT} = this.props;    
    return (
      <>
        <Bs modal
          show={this.state.preview.show}
          onHide={() => this.setState({ preview: { show: false } })}
          centered
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          keyboard={false}
        >
          <Bs modalheader closeButton>Náhled</Bs>
          <Bs modalbody>
            <Bs div className="iframe-wrap">
              <Bs iframe className="iframe" src={this.state.preview.src} />
            </Bs>
          </Bs>0000,0
        </Bs>
        <Dropzone
          className={this.props.className}
          onDrop={(acceptedFiles) => {
            this.pushFile(acceptedFiles);
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <div className="c-dropzone">
              <Row className="mb-2">
                <Col xs={12} {...getRootProps()} className="mb-2">
                  <input {...getInputProps()} />
                  <Row>
                    <Col>
                      <span className="h5">Vyber dokument(y)</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="d-flex align-items-center">
                      <span>Můžeš je sem přetáhnout</span>
                    </Col>
                  </Row>
                </Col>
                <Col
                  data-tip="Vybrat soubory z úložiště zařízení"
                  xs={3}
                  {...getRootProps()}
                  className="d-flex justify-content-center align-items-center cursor-pointer"
                >
                  <input {...getInputProps()} />
                  <Row>
                    <Col>
                      <FaHdd className="fs-20 me-2" />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <span>Zařízení</span>
                    </Col>
                  </Row>
                </Col>
                <Col
                  data-tip="Vybrat soubory z uložené v Heliosu"
                  xs={3}
                  className="d-flex justify-content-center align-items-center cursor-pointer"
                  onClick={() => this.setState({ heg: true })}
                >
                 </Col>
                <Col
                  data-tip="Přidat odkaz na externí soubor"
                  xs={3}
                  className="d-flex justify-content-center align-items-center cursor-pointer"
                  onClick={() => this.setState({ link: true })}
                >
                  <Row>
                    <Col>
                      <GoLinkExternal className="fs-20 me-2" />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <span>Externí</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {this.props.files?.map((f, idx) => (
                <Row className="mb-2 c-dropzone-file">
                  <Col xs={12}>
                    {f.upload == null && (
                      <>
                        <Spinner
                          className="c-dropzone-spinner"
                          variant="danger"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        <AiOutlineUpload className="c-dropzone-spinner-img" />
                      </>
                    )}
                    {f.upload == true && (
                      <>
                        <FaRegCheckCircle
                          data-tip={f.id}
                          className="c-dropzone-spinner-img fs-25 c-success"
                        />
                      </>
                    )}
                    {f.upload == false && (
                      <>
                        <AiOutlineCloseCircle
                          data-tip={f.uploadStatus}
                          className="c-dropzone-spinner-img fs-25 c-danger"
                        />
                      </>
                    )}

                    <span className="c-dropzone-file-name" data-tip={f.name}>
                      {f.name}
                    </span>
                    <span className="c-dropzone-file-size">
                      {f.size > 1024000
                        ? Math.round(f.size / 1000000) + " MB"
                        : Math.round(f.size / 1000) + " KB"}{" "}
                    </span>
                  </Col>
                  {f.upload && (
                    <>
                      <Col>
                        <Button
                          variant="light"
                          className="c-dropzone-file-preview"
                          data-tip="Náhled"
                          onClick={() =>
                            this.setState({
                              preview: { show: true, src: f.content },
                            })
                          }
                        >
                          <MdOutlinePageview className="fs-20 c-secondary" />
                        </Button>
                      </Col>
                      {f.deletable && (
                        <Col>
                          <Button
                            variant="light"
                            className="c-dropzone-file-times"
                            data-tip="Smazat"
                            onClick={() => this.removeEntries(idx)}
                          >
                            <IoCloseOutline className="c-danger fs-20" />
                          </Button>
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              ))}
            </div>
          )}
        </Dropzone>
      </>
    );
  }
}

export default BrtxDropzone;
